import React, { useMemo } from "react";
import { Skeleton } from "antd";

type TableSkeletonProps = {
  rowCount?: number;
};

export default function TableSkeleton({ rowCount = 5 }: TableSkeletonProps) {
  const rowKeys = useMemo(
    () => Array.from({ length: rowCount }, () => crypto.randomUUID()),
    [rowCount]
  );

  return (
    <ul className="divide-y divide-[#EFEFEF]">
      {rowKeys.map((key) => (
        <li
          key={key}
          className="grid grid-cols-[1.2fr_0.7fr_0.8fr_0.7fr] px-6 py-4 items-center"
        >
          {/* col: name + email */}
          <div className="pr-3">
            <div>
              <Skeleton.Input
                active
                size="small"
                style={{ width: "55%", height: 16 }}
              />
            </div>
            <div className="mt-2">
              <Skeleton.Input
                active
                size="small"
                style={{ width: "65%", height: 16 }}
              />
            </div>
          </div>

          {/* col: created on */}
          <div className="flex items-center">
            <Skeleton.Input
              active
              size="small"
              style={{ width: "60%", height: 16 }}
            />
          </div>

          {/* col: contact number */}
          <div className="flex items-center">
            <Skeleton.Input
              active
              size="small"
              style={{ width: "70%", height: 16 }}
            />
          </div>

          {/* col: actions */}
          <div className="flex justify-end items-center gap-5">
            <Skeleton.Button
              active
              size="small"
              style={{ width: 100, height: 20 }}
            />
            <Skeleton.Button
              active
              size="small"
              style={{ width: 100, height: 20 }}
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
